import { InfoCircleOutlined } from '@ant-design/icons';
import { RichTextButton } from '@framework/form';
import { Tooltip } from 'antd';
import * as React from 'react';
import { useController } from 'react-hook-form';

export interface IRichTextInfoInputButtonProps {
  name: string;
}

export function RichTextInfoInputButton(props: IRichTextInfoInputButtonProps) {
  const { name } = props;
  const { field } = useController({ name });

  return (
    <Tooltip title="Imposta come icona informativa" placement="left">
      <RichTextButton
        icon={<InfoCircleOutlined />}
        title="Visualizza come icona informativa"
        isActive={field.value === 'info'}
        onClick={() => {
          field.onChange(field.value === 'info' ? 'text' : 'info');
          field.onBlur();
        }}
      />
    </Tooltip>
  );
}
